export const FORM_NAME = 'cargo-delivery-form';

export const REQUIRED_FIELDS = ['date'];

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';
